import { useContext, useEffect, useState } from 'react'
import { Checkmark, HeartOutline } from '@backyard-ui/icons'

import { getPictures } from 'scripts/react-components/api/Product/pictures'
import * as dataLayer from 'scripts/utils/data-layer'
import emitter from 'scripts/utils/emitter'

import { WishlistContext } from 'site/Wishlist/context'

import { Carousel } from 'catalog/pages/NewProduct/components'
import { CarouselItem } from 'catalog/pages/NewProduct/types'

import * as S from './styled'

interface CarouselContainerProps {
  productId: number
  productName: string
  productPrice: {
    to: {
      integers: string
      decimals: string
    }
  }
}

const CarouselContainer = ({
  productId,
  productName,
  productPrice
}: CarouselContainerProps) => {
  const [carouselItems, setCarouselItems] = useState<CarouselItem[]>([])
  const [buttons, setButtons] = useState({
    hasVideos: false,
    hasSketchFab: false
  })

  const wishlistValues: any = useContext(WishlistContext)
  const isOnWishlist = wishlistValues.isOnWishlist(productId)
  const { onPressHeart } = wishlistValues

  const wishlistAction = (event: Event) => {
    event.stopPropagation()
    dataLayer.midiasCarouselWishlistButtonClick(productId)
    emitter.emit('pdp_emitter:algolia-data-layer')
    onPressHeart(
      {
        inWishList: isOnWishlist,
        id: productId,
        product: { id: productId, shortName: productName, price: productPrice }
      },
      'products'
    )
  }

  const wishListButton = {
    label: isOnWishlist ? 'Adicionado aos Favoritos' : 'Lista de Favoritos',
    icon: isOnWishlist ? Checkmark : HeartOutline,
    onClick: wishlistAction,
    variant: isOnWishlist ? 'solid' : 'ghost'
  }

  useEffect(() => {
    getPictures(productId).then(data => {
      const carouselItems = data.medias.concat(data.sketchFab || [])

      const hasVideos =
        carouselItems.filter((item: CarouselItem) => item.type === 'video')
          .length > 0

      const hasSketchFab =
        carouselItems.filter((item: CarouselItem) => item.type === 'sketchFab')
          .length > 0

      setCarouselItems(carouselItems)

      setButtons({
        hasVideos,
        hasSketchFab
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.Container>
      <Carousel
        carouselItems={carouselItems}
        productId={productId}
        hasVideos={buttons.hasVideos}
        hasSketchFab={buttons.hasSketchFab}
        wishListButton={wishListButton}
      />
    </S.Container>
  )
}

export default CarouselContainer
